export const LEDGER_DISCONNECTED = 'LEDGER_DISCONNECTED';
export const LEDGER_SYNC_START = 'LEDGER_SYNC_START';

export const CLOSE_FORCE_MANUAL_LEDGER_SYNC_MODAL = 'CLOSE_FORCE_MANUAL_LEDGER_SYNC_MODAL';
export const OPEN_FORCE_MANUAL_LEDGER_SYNC_MODAL = 'OPEN_FORCE_MANUAL_LEDGER_SYNC_MODAL';
